module.exports = __webpack_public_path__ + "static/fonts/segoe-ui.c4b43d1f.otf";